//import $ from 'jquery';

export function intiSwapVideo() {
  const videoList = $('.videoList');

  videoList.click(function() {
    const embedCode = $(this).attr('data-path');
    const videoPlayerContainer = $('#tmot-video-player iframe');
    videoPlayerContainer.replaceWith(embedCode);

    const target = $('.galleryContainer--videosContent');
    const targetOffset = target.offset().top - 100;
    $('html, body').animate(
      {
        scrollTop: targetOffset,
      },
      600
    );
  });
}
